import { Link } from "react-router-dom";
import { Button } from "../../ui/components/ui/button";

const PageNotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center space-y-8">
        {/* 404 Number */}
        <div className="space-y-4">
          <h1 className="text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#5FD5DE] to-[#C0DE60]">
            404
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-[#5FD5DE] to-[#C0DE60] mx-auto rounded-full"></div>
        </div>

        {/* German Text */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-slate-800">Seite nicht gefunden</h2>
          <p className="text-slate-600 leading-relaxed">
            Entschuldigung, die Seite, die Sie suchen, existiert nicht oder wurde verschoben. Überprüfen Sie die URL
            oder kehren Sie zur Startseite zurück.
          </p>
        </div>

        {/* Home Button */}
        <div className="pt-4">
          <Link to="/">
            <Button
              variant="brand"
              size="lg"
              className="px-8 py-3 text-base font-medium shadow-lg hover:shadow-xl transition-all duration-200"
            >
              Zur Startseite
            </Button>
          </Link>
        </div>

        {/* Additional Help Text */}
        <div className="pt-8 text-sm text-slate-500">
          <p>
            Benötigen Sie Hilfe?{" "}
            <Link to="/support" className="text-[#5FD5DE] hover:underline">
              Kontaktieren Sie unseren Support
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
